import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { MenuController, NavController, Platform, AlertController, LoadingController, ToastController } from '@ionic/angular';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { GetServiceService } from './services/getService/get-service.service';
import { PostServiceService } from './services/postService/post-service.service';
import { pubnubKeys } from '../environments/environment';
import { PubNubAngular } from 'pubnub-angular2';
import { VersionUpdateCheckService } from './version-update-check.service';
import { UserStateService } from './services/user-state.service';
import { Subscription } from 'rxjs';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SafeArea } from '@capacitor-community/safe-area';
import { Router } from '@angular/router';
import { CartService } from './services/cart/cart.service';
import { PushNotificationService } from './services/push-notification.service';
// import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import {firebaseConfig} from '../environments/environment'
// import { FCM } from '@ionic-native/fcm/ngx';
// import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic';
// import { FirebaseX } from "@ionic-native/firebase-x/ngx";

// const firebaseConfig = {
//   apiKey: "AIzaSyAvs2ry2d6aJGcGyesSqZfXojppZb5JkJc",
//   authDomain: "happy-duckers.firebaseapp.com",
//   projectId: "happy-duckers",
//   storageBucket: "happy-duckers.appspot.com",
//   messagingSenderId: "962413917269",
//   appId: "1:962413917269:web:9cab687887339750be90dc",
//   measurementId: "G-G7G1G2RHCM"
// };

// import { initializeApp } from 'firebase/app';
// const app = initializeApp(firebaseConfig);

declare var PubNub: any
declare var cordova: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnChanges, OnDestroy {
  public pubnubMessage: any;
  your_appcomponent_member = '';
  public user: any;
  public isAdmin: boolean = false;
  public maxWidth: any = '(min-width: 1025px)';
  private adminSubscription: Subscription | undefined;

  constructor(
    private sidemenu: MenuController,
    private navCtrl: NavController,
    private platform: Platform,
    private androidPermissions: AndroidPermissions,
    private alertController: AlertController,
    public geolocation: Geolocation,
    public getService: GetServiceService,
    public postService: PostServiceService,
    public loadingController: LoadingController,
    private pubnub: PubNubAngular,
    private sw: VersionUpdateCheckService,
    private toastController: ToastController,
    private userStateService: UserStateService,
    private router: Router,
    private cartService: CartService,
    private pushNotificationService: PushNotificationService,
    // private fcm: FCM,
    // private firebase: FirebaseX
  ) {

    this.initializeGoogleSignIn();
    // initializeApp(firebaseConfig);

    // this.firebase.getToken().then((token: any) => {
    //   console.log(`The token is ----> ${token}`);
    // })
    // this.firebase.onMessageReceived().subscribe((data: any) => {
    //   console.log(`FCM message: ----> ${data}`)
    // });

    this.sw.checkForUpdates();

    this.initializeApp();

    this.pubnub = pubnub;
    this.pubnub.init({
      publishKey: pubnubKeys.pubNubPublishKey,
      subscribeKey: pubnubKeys.pubNubSubscribeKey,
      uuid: pubnubKeys.channel,
      // logVerbosity: true,
      ssl: true
    });
  }

  ngOnInit() {
    console.log('app component ng on init -->');

    if (localStorage.getItem('isProducts')) {
      this.your_appcomponent_member = 'productsAvailable';
    }

    // Subscribe to admin status changes
    this.adminSubscription = this.userStateService.isAdmin$.subscribe(isAdmin => {
      this.isAdmin = isAdmin;
      console.log('Admin status updated:', this.isAdmin);
    });
    
    // Check initial admin status
    this.userStateService.checkAdminStatus();

    this.platform.ready().then(async () => {
      console.log('platform is ready -->');

      // Configure StatusBar for proper Android safe area handling
      if (this.platform.is('capacitor')) {
        try {
          // Modern approach: Use SafeArea plugin for consistent behavior
          await SafeArea.enable({
            config: {
              customColorsForSystemBars: true,
              statusBarColor: '#000000', // Dark status bar to match app theme
              statusBarContent: 'light', // light content on dark background
              navigationBarColor: '#000000', // Dark navigation bar to fill bottom area
              navigationBarContent: 'light',
            },
          });
          
          // Fallback StatusBar configuration
          await StatusBar.setOverlaysWebView({ overlay: false });
          await StatusBar.setStyle({ style: Style.Dark });
          await StatusBar.setBackgroundColor({ color: '#000000' });
          
          console.log('StatusBar and SafeArea configured successfully');
        } catch (error) {
          console.error('StatusBar configuration error:', error);
        }
      }

      // UXCam removed - no longer tracking user sessions
      // if (this.platform.is('cordova')) {
      //   this.checkBackgroundPermission();
      // } else {
      //   this.getCurrentLocation();
      // }
    });

    // pubnub code started
    this.pubnub.subscribe({
      channels: [pubnubKeys.channel],
      triggerEvents: true,
      withPresence: true,
      autoload: 100
    });
    this.pubnub.getMessage(pubnubKeys.channel, (msg) => {
      if (msg.message.title === 'App Refresh') {
        console.log("App Refresh");
        console.log("data -->", JSON.parse(msg.message.data));
      }
    });
    console.log('before pubnub publish')
    this.pubnub.publish(
      {
        message: {
          such: 'Hello!'
        },
        channel: "happy-duckers",
      },
      function (status, response) {
        console.log('pubnub response from publish');
        console.dir(status);
        console.log(status)

        if (status.error) {
          console.log('pubnub error')
          console.dir(status);
          console.log(status)
          console.log('pubnub error detail ' + status.error);
          console.log(JSON.stringify(status, null, 4));
        } else {
          console.log("message Published w/ timetoken", response.timetoken)
        }
      }
    );
  }


  initializeGoogleSignIn() {
    this.platform.ready().then(() => {
      console.log('READY!')
      // GoogleAuth.initialize(
      //   {
      //   clientId:'962413917269-29skqci2vu3q21o9s3if109gfkvjunqb.apps.googleusercontent.com',
      //   scopes: ['profile', 'email'],
      //   grantOfflineAccess: true,
      // }
      // )
    })
  }

  async alertPopup(title: string, msg: string) {
    const alert = await this.alertController.create({
      header: title,
      message: msg,
      buttons: [{
        text: 'Okay'
      }]
    });
    await alert.present();
  }


  ngOnChanges() {
    this.user = localStorage.getItem('user');
    console.log('this.user onchanges', this.user);
    
    // Update admin status when user changes
    this.userStateService.checkAdminStatus();
  }
  
  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    if (this.adminSubscription) {
      this.adminSubscription.unsubscribe();
    }
  }

  /**
   * Clear badge count when app becomes active (user is engaging with the app)
   */
  private clearBadgeWhenAppActive() {
    // Clear badge when app launches (user is actively using the app)
    this.pushNotificationService.clearBadgeCount().then(success => {
      if (success) {
        console.log('Badge count cleared on app activation');
      }
    });

    // Listen for app state changes to clear badge when user returns to app
    App.addListener('appStateChange', async (state) => {
      if (state.isActive) {
        console.log('App became active - clearing badge count');
        await this.pushNotificationService.clearBadgeCount();
      }
    });
  }

  private async checkBackgroundPermission() {
    try {
      console.log('line 28 --->');
      const resultBackground = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION);
      const resultCoarse = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION);
      const resultFine = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION);
      console.log('line 30 bg --->', resultBackground, JSON.stringify(resultBackground));
      console.log('line 30 co --->', resultCoarse, JSON.stringify(resultCoarse));
      console.log('line 30 fine --->', resultFine, JSON.stringify(resultFine));
      if (!resultBackground || resultBackground.hasPermission === false) {
        this.requestPermissions();
      } else {
        this.getCurrentLocation();
      }
    } catch (error) {
      console.log("line 35 ---->", error, JSON.stringify(error));
      this.requestPermissions();
    }
  }

  private async requestPermissions() {
    try {
      console.log('line 42 --->');
      const data = await this.androidPermissions.requestPermissions([
        "android.permission.ACCESS_BACKGROUND_LOCATION",
        "android.permission.ACCESS_COARSE_LOCATION",
        "android.permission.INTERNET",
        "android.permission.ACCESS_NETWORK_STATE",
        this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
      ]);
      console.log('line 48 --->', data, JSON.stringify(data));
      if (!data.hasPermission) {
        throw new Error('No permission');
      } else {
        this.getCurrentLocation();
      }
    } catch (error) {
      console.log(
        'Background location',
        'We need background location access in order to continue.'
      );
    }
  }

  getCurrentLocation() {
    console.log("getCurrentLocation -->");
    this.geolocation.getCurrentPosition().then((resp: any) => {
      console.log('geolocation response', resp);
      console.log('geolocation response', JSON.stringify(resp));
      localStorage.setItem("userLocation", JSON.stringify({
        latitude: resp.coords.latitude,
        longitude: resp.coords.longitude
      }));
    }).catch((error: any) => {
      console.log('geolocation erroe', error);
      console.log('geolocation erroe', JSON.stringify(error));
    });
  }

  async logout() {

    const alert = await this.alertController.create({
      header: 'Warning',
      message: 'Are you sure you want to logout?',
      buttons: [{
        text: 'Yes',
        handler: () => {
          this.sidemenu.enable(false);
          localStorage.removeItem("user");
          this.userStateService.clearUserState();
          this.navCtrl.navigateRoot("/login");
        }
      }, {
        text: 'No',
        handler: () => {
        }
      }]
    });
    alert.present()

    // if (localStorage.getItem('fcmDeviceId')) {
    //   this.postService.logout({ fcmDeviceId: localStorage.getItem('fcmDeviceId') }).subscribe(
    //     (res: any) => {
    //       console.log('logout --> ', res);
    //     }, (err: any) => {
    //       console.log('logout error --> ', err);
    //     });
    // }
  }

  redirect(url: any) {
    this.navCtrl.navigateRoot(url);
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      
      // Set up deep link handling
      App.addListener('appUrlOpen', (data) => {
        console.log('App opened with URL:', data.url);
        this.handleDeepLink(data.url);
      });
      
      // Check for initial URL when app starts (for Universal Links)
      const initialUrl = await App.getLaunchUrl();
      if (initialUrl && initialUrl.url) {
        console.log('App launched with URL:', initialUrl.url);
        // Add a small delay to ensure app is fully initialized
        setTimeout(() => {
          this.handleDeepLink(initialUrl.url);
        }, 1000);
      }
      
      // Handle app resume from background (e.g., returning from Stripe checkout)
      App.addListener('appStateChange', (state) => {
        console.log('App state changed:', state);
        if (state.isActive) {
          // App has become active/resumed
          // First check if we have a launch URL that wasn't processed
          setTimeout(async () => {
            const launchUrl = await App.getLaunchUrl();
            if (launchUrl && launchUrl.url) {
              console.log('Found launch URL on app resume:', launchUrl.url);
              this.handleDeepLink(launchUrl.url);
              return; // Exit early if we found a launch URL
            }
            
            // Otherwise check if we have a pending Stripe session
            const pendingSession = localStorage.getItem('pending_stripe_session');
            if (pendingSession) {
              console.log('Found pending Stripe session:', pendingSession);
              // Add a small delay to ensure the payment has been processed
              setTimeout(() => {
                // Check payment status with backend
                this.checkStripePaymentStatus(pendingSession);
              }, 2000);
            }
          }, 500);
        }
      });

      // if (this.platform.is("cordova")) {

      //   window.open = cordova.InAppBrowser.open;
      //   await FCM.getToken().then(token => {
      //     localStorage.setItem('fcmDeviceId', token);
      //     console.log(token, 'in here');
      //   }).catch(err => {
      //     console.log('fcmtoken_err1', err);
      //     alert('getToken error: ' + err);
      //   });

      //   FCM.onTokenRefresh().subscribe(token => {
      //     localStorage.setItem('deviceId', token);
      //     console.log(token, 'in refresh');
      //   });

      //   FCM.onNotification().subscribe((data: any) => {
      //     console.log('onNotification DATA -->', data);
      //     console.log('onNotification DATA -->', JSON.stringify(data));
      //     if (data.wasTapped) {
      //       console.log('Received in background');
      //       this.presentToast(data.title, "Received in background -> " + data.body, 'success', 3000);
      //     } else {
      //       console.log('Received in foreground');
      //       this.presentToast(data.title, "Received in foreground -> " + data.body, 'success', 3000);
      //     }
      //   });

      //   FCM.subscribeToTopic('peopleToTest');
      // }
      
      // Initialize push notifications if user is logged in
      const user = localStorage.getItem('user');
      if (user) {
        console.log('User is logged in, initializing push notifications');
        this.pushNotificationService.initialize().then(() => {
          console.log('Push notifications initialized');
          
          // Clear badge count when app becomes active (user is engaging with the app)
          this.clearBadgeWhenAppActive();
        }).catch(error => {
          console.error('Error initializing push notifications:', error);
        });
      } else {
        console.log('User not logged in, skipping push notification initialization');
      }
    });
  }
  
  handleDeepLink(url: string) {
    console.log('🔗 Handling deep link:', url);
    
    // Parse the URL to extract route and params
    if (url.includes('cart/recover')) {
      console.log('🛒 Processing cart recovery deep link');
      
      // Extract parameters from URL
      const urlParts = url.split('?');
      if (urlParts.length > 1) {
        const params = new URLSearchParams(urlParts[1]);
        const cartId = params.get('cartId');
        const code = params.get('code');
        
        console.log('📦 Cart recovery - Cart ID:', cartId, 'Code:', code);
        
        // Navigate to cart recovery page with parameters
        setTimeout(() => {
          this.navCtrl.navigateRoot(['/cart-recovery'], {
            queryParams: { 
              id: cartId,  // The cart-recovery page expects 'id' not 'cartId'
              code: code 
            },
            replaceUrl: true
          }).then(() => {
            console.log('✅ Successfully navigated to cart-recovery page');
          }).catch((error) => {
            console.error('❌ Navigation error:', error);
          });
        }, 100);
      }
    } else if (url.includes('order-success')) {
      console.log('✅ Processing order-success deep link');
      
      // Extract session_id from URL
      const urlParts = url.split('?');
      if (urlParts.length > 1) {
        const params = new URLSearchParams(urlParts[1]);
        const sessionId = params.get('session_id');
        
        console.log('💳 Found session ID:', sessionId);
        
        // Clear pending session since payment succeeded
        localStorage.removeItem('pending_stripe_session');
        
        // Force navigation to native order success page
        console.log('🚀 Navigating to native order-success page');
        
        // Use a more explicit navigation approach
        setTimeout(() => {
          this.navCtrl.navigateRoot(['/order-success'], {
            queryParams: { session_id: sessionId },
            replaceUrl: true
          }).then(() => {
            console.log('✅ Successfully navigated to order-success page');
            
            // Clear the cart since payment was successful
            this.cartService.clearCart();
            
            // Show success message
            this.presentToast('Success', 'Payment completed successfully!', 'success', 3000);
          }).catch((error) => {
            console.error('❌ Navigation error:', error);
          });
        }, 100);
        
      } else {
        console.log('🚀 Navigating to order-success without session ID');
        this.navCtrl.navigateRoot('/order-success', { replaceUrl: true });
      }
    } else if (url.includes('shopping-cart')) {
      console.log('🛒 Processing shopping-cart deep link');
      
      // User cancelled payment
      localStorage.removeItem('pending_stripe_session');
      
      setTimeout(() => {
        this.navCtrl.navigateRoot('/shopping-cart', { replaceUrl: true }).then(() => {
          console.log('✅ Successfully navigated to shopping-cart page');
        });
      }, 100);
    }
    
    console.log('🔗 Deep link handling complete');
  }
  
  checkStripePaymentStatus(sessionId: string) {
    // Check payment status with backend
    this.getService.getCheckoutSessionStatus(sessionId).subscribe(
      (response: any) => {
        console.log('Payment status response:', response);
        if (response.status === 'paid' || response.payment_status === 'paid') {
          // Payment successful, clear pending session
          localStorage.removeItem('pending_stripe_session');
          
          // Clear the cart since payment was successful
          this.cartService.clearCart();
          
          // Navigate to success page
          this.navCtrl.navigateRoot(['/order-success'], {
            queryParams: { session_id: sessionId }
          });
          
          // Show success message
          this.presentToast('Success', 'Payment completed successfully!', 'success', 3000);
        } else {
          // Payment not completed, clear pending session
          localStorage.removeItem('pending_stripe_session');
          
          // Stay on current page or navigate to cart
          if (!this.router.url.includes('shopping-cart')) {
            this.navCtrl.navigateRoot('/shopping-cart');
          }
        }
      },
      (error: any) => {
        console.error('Error checking payment status:', error);
        // Clear pending session on error
        localStorage.removeItem('pending_stripe_session');
      }
    );
  }

  async presentToast(header: any, message: any, color: any, duration: any) {
    const toast = await this.toastController.create({
      message: message,
      header: header,
      position: "top",
      color: color,
      duration: duration,
    });
    toast.present();
  }

}
